<header class="topbar">
  <div class="topbar__inner">
    <!-- Logo: color en claro, blanco en oscuro -->
    <a routerLink="/" class="topbar__logo" aria-label="Inicio">
      <img
        [src]="
          theme.isDark()
            ? 'assets/img/logo/logo-todosector-base-white.png'
            : 'assets/img/logo/logo-todosector-base.png'
        "
        alt="Logotipo {{ app.business.name || '' }}" />
    </a>

    <!-- Anclas (desktop) -->
    <nav class="topbar__nav">
      @for (item of topbarLinks; track item.link) {
        <a
          [routerLink]="item.link"
          routerLinkActive="is-active"
          class="topbar__nav-link">
          {{ item.label }}
        </a>
      }
    </nav>

    <div class="topbar__actions">
      <!-- Toggle día/noche -->
      <p-toggleswitch
        class="theme-toggle"
        [ngModel]="theme.isDark()"
        (onChange)="theme.toggle()"
        ariaLabel="Cambiar tema claro u oscuro">
        <ng-template #handle let-checked="checked">
          <i class="pi" [ngClass]="checked ? 'pi-moon' : 'pi-sun'"></i>
        </ng-template>
      </p-toggleswitch>

      <!-- CTA primaria (desktop) -->
      <a routerLink="/prueba-sin-compromiso" class="topbar__cta">Prueba 14 días</a>

      <!-- Hamburguesa -->
      <button
        type="button"
        class="topbar__burger"
        (click)="drawerVisible = true"
        aria-label="Abrir menú">
        <span></span><span></span><span></span>
      </button>
    </div>
  </div>
</header>

<!-- Drawer lateral derecho -->
<p-drawer
  [(visible)]="drawerVisible"
  position="right"
  styleClass="ts-drawer"
  [style]="{ width: '100%', maxWidth: '420px' }"
  [baseZIndex]="10000">
  <nav class="drawer-nav">
    @for (item of drawerLinks; track item.link; let first = $index) {
      <a
        [routerLink]="item.link"
        [routerLinkActiveOptions]="{ exact: !!item.exact }"
        routerLinkActive="is-active"
        (click)="closeDrawer()"
        class="drawer-nav__item">
        {{ item.label }}
      </a>
    }
  </nav>

  <div class="drawer-foot">
    <a
      routerLink="/prueba-sin-compromiso"
      (click)="closeDrawer()"
      class="drawer-foot__access">
      Acceder
    </a>

    <img
      class="drawer-foot__logo"
      [src]="
        theme.isDark()
          ? 'assets/img/logo/logo-todosector-base-white.png'
          : 'assets/img/logo/logo-todosector-base.png'
      "
      alt="Logotipo {{ app.business.name || '' }}" />
  </div>
</p-drawer>
